module.exports = __webpack_public_path__ + "public/img/move_down.64a01697.svg";